/**
 *  @fileOverview UTM Leads Module, initialise and generate UTM Fields
 *
 *  @author       Andrew Dunbar & Aaron Chapman
 *
 */

function UTMLeadsModule () {
  /**
  * @description Initialises UTM Fields for form instances.
  *
  * @example
  * //
  * @returns {null} // null.
  */
  this.init = function () {
    // Establish the five parameters we might be able to get from the url
    const gclidParam = this.getParamLeads('gclid')
    const utmSource = this.getParamLeads('utm_source')
    const utmMedium = this.getParamLeads('utm_medium')
    const utmCampaign = this.getParamLeads('utm_campaign')
    const utmContent = this.getParamLeads('utm_content')

    // For 'Google Ads' - define what the forms fields we are looking for are
    const gclidFormFields = ['gclid', 'GCLID__c']
    let gclidRecord = null
    let currGclidFormField

    // For 'UTMs' - define what the forms fields we are looking for are
    const utmFormFieldsSource = ['UTM_Source__c']
    let utmRecordSource = null
    let currutmFormFieldSource

    const utmFormFieldsMedium = ['UTM_Medium__c']
    let utmRecordMedium = null
    let currutmFormFieldMedium

    const utmFormFieldsCampaign = ['UTM_Campaign__c']
    let utmRecordCampaign = null
    let currutmFormFieldCampaign

    const utmFormFieldsContent = ['UTM_Content__c']
    let utmRecordContent = null
    let currutmFormFieldContent

    // This code is just for older Google Adwords (i think)
    const gclsrcParam = this.getParamLeads('gclsrc')
    const isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1

    // Use field arrays to check existence of form fields
    currGclidFormField = this.getFormField(gclidFormFields)
    currutmFormFieldSource = this.getFormField(utmFormFieldsSource)
    currutmFormFieldMedium = this.getFormField(utmFormFieldsMedium)
    currutmFormFieldCampaign = this.getFormField(utmFormFieldsCampaign)
    currutmFormFieldContent = this.getFormField(utmFormFieldsContent)

    // Test to see whether there was a value 'gclidParam' in the url and if so set an expiry.
    if (gclidParam && isGclsrcValid) {
      gclidRecord = this.getExpiryRecord(gclidParam)
      localStorage.setItem('gclid', JSON.stringify(gclidRecord))
    }

    // Test to see whether there was a value 'utm_source' and 'utm_medium' and 'utm_campaign' in the url and if so set an expiry.
    if (utmSource && utmMedium && utmCampaign) {
      utmRecordSource = this.getExpiryRecord(utmSource)
      localStorage.setItem('utm_source', JSON.stringify(utmRecordSource))

      utmRecordMedium = this.getExpiryRecord(utmMedium)
      localStorage.setItem('utm_medium', JSON.stringify(utmRecordMedium))

      utmRecordCampaign = this.getExpiryRecord(utmCampaign)
      localStorage.setItem('utm_campaign', JSON.stringify(utmRecordCampaign))

      // Test to see whether there was a value 'utm_content' in the url and if so set an expiry.
      if (utmContent) {
        utmRecordContent = this.getExpiryRecord(utmContent)
        localStorage.setItem('utm_content', JSON.stringify(utmRecordContent))
      }
    }

    // Set 'gclid' value from the captured url var, or from localStorage.
    const gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'))

    // Set 'uSource' value from the captured url var, or from localStorage.
    const uSource = utmRecordSource || JSON.parse(localStorage.getItem('utm_source'))

    // Set 'uMedium' value from the captured url var, or from localStorage.
    const uMedium = utmRecordMedium || JSON.parse(localStorage.getItem('utm_medium'))

    // Set 'uCampaign' value from the captured url var, or from localStorage.
    const uCampaign = utmRecordCampaign || JSON.parse(localStorage.getItem('utm_campaign'))

    // Set 'uContent' value from the captured url var, or from localStorage.
    const uContent = utmRecordContent || JSON.parse(localStorage.getItem('utm_content'))

    // If form attribute in DOM and value from url/localStage is valid.
    if (currGclidFormField && this.isRecordValid(gclid)) {
      currGclidFormField.value = gclid.value
    }

    // If form attribute in DOM and value from url/localStage is valid.
    if (currutmFormFieldSource && this.isRecordValid(uSource)) {
      currutmFormFieldSource.value = uSource.value
    }

    // If form attribute in DOM and value from url/localStage is valid.
    if (currutmFormFieldMedium && this.isRecordValid(uMedium)) {
      currutmFormFieldMedium.value = uMedium.value
    }

    // If form attribute in DOM and value from url/localStage is valid.
    if (currutmFormFieldCampaign && this.isRecordValid(uCampaign)) {
      currutmFormFieldCampaign.value = uCampaign.value
    }

    // If form attribute in DOM and value from url/localStage is valid.
    if (currutmFormFieldContent && this.isRecordValid(uContent)) {
      currutmFormFieldContent.value = uContent.value
    }
  }

  this.getParamLeads = function (p) {
    const match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search)
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
  }

  this.getFormField = function (fields) {
    // Loop through the defined form fields and see whether they are in the DOM
    let formField

    fields.forEach(function (field) {
      if (document.getElementById(field)) {
        formField = document.getElementById(field)
      }
    })

    return formField
  }

  this.getExpiryRecord = function (value) {
    const expiryPeriod = 90 * 24 * 60 * 60 * 1000 // 90 day expiry in milliseconds
    const expiryDate = new Date().getTime() + expiryPeriod

    return {
      value: value,
      expiryDate: expiryDate
    }
  }

  this.isRecordValid = function (record) {
    let validity = false

    if (record !== null) {
      if (new Date().getTime() < record.expiryDate) {
        validity = true
      }
    }

    return validity
  }

  this.hasQueryString = function (url) {
    let match = false
    const pattern = new RegExp(/\?.+=.*/g)

    match = pattern.test(url)

    return match
  }

  this.setUTM = function (elements) {
    const gclid = JSON.parse(localStorage.getItem('gclid'))
    const uSource = JSON.parse(localStorage.getItem('utm_source'))
    const uMedium = JSON.parse(localStorage.getItem('utm_medium'))
    const uCampaign = JSON.parse(localStorage.getItem('utm_campaign'))
    const uContent = JSON.parse(localStorage.getItem('utm_content'))

    let utmParamQueryString = ''
    let utmParamQueryStringTrimmed = ''

    if (this.isRecordValid(gclid)) {
      utmParamQueryString += '&gclid=' + gclid.value
    }

    if (this.isRecordValid(uSource)) {
      utmParamQueryString += '&utm_source=' + uSource.value
    }

    if (this.isRecordValid(uMedium)) {
      utmParamQueryString += '&utm_medium=' + uMedium.value
    }

    if (this.isRecordValid(uCampaign)) {
      utmParamQueryString += '&utm_campaign=' + uCampaign.value
    }

    if (this.isRecordValid(uContent)) {
      utmParamQueryString += '&utm_content=' + uContent.value
    }

    if (utmParamQueryString.length > 0) {
      // Trim the initial & off the query string we have built
      utmParamQueryStringTrimmed = utmParamQueryString.substring(1)
      // Add ? to the start of our query string
      utmParamQueryStringTrimmed = '?' + utmParamQueryStringTrimmed

      elements.forEach(element => {
        const elemURL = element.getAttribute('href')
        let newURL

        if (this.hasQueryString(elemURL)) {
          newURL = elemURL + utmParamQueryString
        } else {
          newURL = elemURL + utmParamQueryStringTrimmed
        }

        element.setAttribute('href', newURL)
      })
    }
  }
}
module.exports = UTMLeadsModule
